import { FetchState } from 'src/enums/FetchState';

import { AuthenticatedUserProfileDto } from 'src/services/account/AuthenticatedUserProfileDto';

import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';

import { fetchRequest } from 'src/utils/fetchRequest';

import { LoginRequestData } from './LoginDtos';

type LoginPromise = Promise<{
	authenticatedUserProfile?: AuthenticatedUserProfile | undefined;
	state: FetchState;
	status: number;
	statusText: string;
}>;

export async function loginRequest(formData: LoginRequestData): LoginPromise {
	try {
		const response = await fetchRequest(process.env.NEXT_PUBLIC_SITECORE_LOGIN_URL || '', formData);

		if (!response.ok) {
			throw response.statusText;
		}

		const data = await response.json();

		if (!data.AuthenticatedUserProfile) {
			return { state: FetchState.WARNING, status: response.status, statusText: response.statusText };
		}

		const authenticatedUserProfile: AuthenticatedUserProfile = formatAuthenticatedUserProfile(data.AuthenticatedUserProfile);

		return {
			authenticatedUserProfile,
			state: FetchState.SUCCESS,
			status: response.status,
			statusText: response.statusText,
		};
	} catch (error) {
		console.error(error);
		return {
			state: FetchState.ERROR,
			status: 500,
			statusText: 'Server error - Something went wrong API server side',
		};
	}
}

export function formatAuthenticatedUserProfile(dto: AuthenticatedUserProfileDto): AuthenticatedUserProfile {
	const serializedData = JSON.stringify(dto);
	const authenticatedUserProfile: AuthenticatedUserProfile = JSON.parse(serializedData, (_, val) => {
		if (Array.isArray(val) || typeof val !== 'object' || val === undefined || val === null) {
			return val;
		}
		return Object.entries(val).reduce((a: Record<string, unknown>, [key, val]) => {
			a[key.charAt(0).toLowerCase() + key.slice(1)] = val;
			return a;
		}, {});
	});

	return authenticatedUserProfile;
}
